module.exports = __webpack_public_path__ + "assets/fonts/segoeui-regular-865f1db6545fc94a2f4444dd60e7bbc6.woff2";